export const altMainMedia = state => state.getIn(['tour', 'altMainMedia'])
export const client = state => state.get('tour').get('client')
export const fromVR = state => state.getIn(['tour', 'fromVR'])
export const loadSingleStopOnly = state => state.getIn(['tour', 'loadSingleStopOnly'])
export const isAutoPlayBlocked = state => state.getIn(['tour', 'isAutoPlayBlocked'])
export const isAutoPlayEnabled = state => state.getIn(['tour', 'isAutoPlayEnabled'])
export const isSkipButtonVisible = state => state.getIn(['tour', 'isSkipButtonVisible'])
export const isWindowFullScreen = state => state.getIn(['tour', 'isWindowFullScreen'])
export const locationIndex = state =>
    state
        .get('tour')
        .get('locations')
        .get('current')
export const locationsList = state =>
    state
        .get('tour')
        .get('locations')
        .get('list')
export const mainMediaInitialized = state => state.getIn(['tour', 'mainMedia', 'initialized'])
export const mainMediaLoadingStatus = state => state.getIn(['tour', 'mainMedia', 'loadingStatus'])
export const originalPlatform = state => state.get('tour').get('originalPlatform')
export const platform = state => state.get('tour').get('platform')
export const pointIndex = state =>
    state
        .get('tour')
        .get('points')
        .get('current')
export const points = state => state.get('tour').get('points')
export const pointsRawList = state =>
    state
        .get('tour')
        .get('points')
        .get('list')
export const regWelcomePrompt = state => state.getIn(['tour', 'registration', 'welcomePrompt'])
export const skippedAltMainMedia = state => state.getIn(['tour', 'skippedAltMainMedia'])
export const stopIndex = state => state.getIn(['tour', 'stops', 'current'])
export const stopsList = state => state.getIn(['tour', 'stops', 'list'])
export const toggleDescriptionVisible = state => state.get('tour').get('toggleDescriptionVisible')
export const tourError = state => state.get('tour').get('error')
export const tourHintButton = state => state.get('tour').get('tourHintButton')
export const tourLoading = state => state.get('tour').get('loading')
export const tourid = state =>
    state
        .get('tour')
        .get('tours')
        .get('current')
export const toursList = state =>
    state
        .get('tour')
        .get('tours')
        .get('list')
export const trailIndex = state =>
    state
        .get('tour')
        .get('trails')
        .get('current')
export const trailsList = state =>
    state
        .get('tour')
        .get('trails')
        .get('list')
export const visited = state => state.getIn(['tour', 'stops', 'visited'])
export const welcomePrompt = state => state.getIn(['tour', 'welcomePrompt'])
